import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const ForgotPasswordModule = {
  namespaced: true,
  state: {
    resetPasswordParams: {
      msisdn: null,
      channel: null,
      view: 'msisdn',
      validityPeriod: null
    }
  },
  actions: {
    async performResetChannel ({ commit, state, rootGetters }, channel) {
      const apolloClient = getProvider().defaultClient
      state.resetPasswordParams.channel = channel
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation forgotPassword ($input: ResetPasswordInput!){
          resetPassword (resetPasswordInput: $input){
            validityPeriod
          },
        }`,
        variables: {
          input: {
            msisdn: state.resetPasswordParams.msisdn,
            channel: state.resetPasswordParams.channel,
            brand: rootGetters.brand
          }
        }
      }).then((response) => {
        if (response.data.resetPassword.validityPeriod !== null) {
          commit('resetPerformedSuccessfullyChannel', {
            channel: channel,
            validityPeriod: response.data.resetPassword.validityPeriod
          })
          commit('Transaction/removeTransactionId', 'forgotPassword', { root: true })
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    captureMsisdn (state, msisdn) {
      state.resetPasswordParams.msisdn = msisdn
      state.resetPasswordParams.view = 'channel'
    },
    recaptureMsisdn (state, channel) {
      if (state.resetPasswordParams.view !== 'channel') {
        return
      }
      state.resetPasswordParams.view = 'msisdn'
      state.resetPasswordParams.channel = channel
    },
    resetPerformedSuccessfullyChannel (state, { channel, validityPeriod }) {
      if (state.resetPasswordParams.view !== 'channel') {
        return
      }
      if (channel === 'email') {
        state.resetPasswordParams.view = 'succeeded'
      } else if (channel === 'sms') {
        state.resetPasswordParams.view = 'succeededSms'
      }
      state.resetPasswordParams.channel = channel
      state.resetPasswordParams.validityPeriod = validityPeriod
    },
    restartProcess (state) {
      if (state.resetPasswordParams.view === 'succeeded' || state.resetPasswordParams.view === 'succeededSms') {
        state.resetPasswordParams.view = 'msisdn'
      }
    },
    setView (state, viewState) {
      state.resetPasswordParams.view = viewState
    }
  },
  getters: {
    msisdn (state) {
      return state.resetPasswordParams.msisdn
    },
    validityPeriod (state) {
      return state.resetPasswordParams.validityPeriod
    },
    channel (state) {
      return state.resetPasswordParams.channel
    },
    view: state => {
      return state.resetPasswordParams.view
    }
  }
}

export {
  ForgotPasswordModule
}
